import { scrollToRef } from '@/common/utils/scroll-to-ref';
import { useCallback, useRef, useState } from 'react';

/**
 * Hook to manage refs for plan selection error guides that display as popovers and to scroll to them when a user tries to continue without selecting a plan.
 * It also manages the logic for auto-dismissing the error guide after 3 seconds.
 */
export default function usePlanSelectionErrorGuides() {
  const [dismissedPlanGuide, setDismissedPlanGuide] = useState(true);
  const mileagePlanSectionRef = useRef(null);
  const insurancePlanSectionRef = useRef(null);

  const scrollToMileagePlanSection = useCallback(() => {
    scrollToRef(mileagePlanSectionRef, 'top', 100);
    setDismissedPlanGuide(false);

    // Auto-dismiss the plan guide popover after 3 seconds
    const timeout = setTimeout(() => {
      setDismissedPlanGuide(true);
    }, 3000);

    return () => clearTimeout(timeout);
  }, [mileagePlanSectionRef]);

  const scrollToInsurancePlanSection = useCallback(() => {
    scrollToRef(insurancePlanSectionRef, 'top', 100);
    setDismissedPlanGuide(false);

    // Auto-dismiss the plan guide popover after 3 seconds
    const timeout = setTimeout(() => {
      setDismissedPlanGuide(true);
    }, 3000);

    return () => clearTimeout(timeout);
  }, [insurancePlanSectionRef]);

  return {
    dismissedPlanGuide,
    mileagePlanSectionRef,
    insurancePlanSectionRef,
    scrollToMileagePlanSection,
    scrollToInsurancePlanSection,
  };
}
